import autoBind from 'auto-bind'

import { ActionResult, PaginatedResponse, ResponseData, TableParams } from 'api/domain/app'
import { PurchasedProduct, PurchasedInfo, Tag, Filters } from 'api/domain/images'
import { AppApiBase } from 'api/core/AppApiBase'

export class ImagesApi {
  constructor(protected api: AppApiBase) {
    // @ts-ignore
    this.api.axiosClient.defaults.paramsSerializer = (params: any) => {
      const p = new URLSearchParams()
      Object.keys(params).map(key => {
        if (Array.isArray(params[key]) && params[key].length > 0) {
          params[key].map((i: any) => i !== undefined && p.append(key, i))
        } else {
          params[key] !== undefined && p.append(key, params[key])
        }
        return null
      })

      return p
    }

    autoBind(this)
  }

  fetchImages(params?: TableParams) {
    return this.api.get<any>('/products', { ...params })
  }
  getImageById(id: string) {
    return this.api.get<PurchasedProduct>(`/products/${id}`)
  }

  getPrivateImageById(id: string) {
    return this.api.get<PurchasedProduct>(`/products/${id}`)
  }

  purchaseImageById(params: { product_id: string }) {
    return this.api.post<ActionResult>(`/purchases`, {
      ...params,
      params: {},
    })
  }

  getPurchasedImages(params?: TableParams) {
    return this.api.get<ResponseData<PurchasedInfo[]> & { total: number }>(`/purchases`, {
      ...params,
    })
  }

  downloadImageById(id: string) {
    return this.api.get<PurchasedInfo>(`/images/${id}/download`)
  }

  removeImageFromFavourite(id: string) {
    return this.api.delete<ActionResult>(`/images/favorites/${id}`)
  }

  getFavouritesImages(params?: TableParams) {
    return this.api.get<PaginatedResponse<PurchasedInfo>>(`/images`, {
      ...params,
      is_favorite: true,
    })
  }
  getFilters() {
    return this.api.get<Filters>(`/products/filter-options`)
  }
}
